import api from './api';
import {
  ApiResponse,
  DataImportRun,
  OpportunityContactLookup,
  OpportunityFilters,
  OpportunityPage,
} from '../types';

export const opportunityService = {
  // Admin: postos do cadastro da ANP ainda sem dono, com os preços da última pesquisa da ANP
  async list(filters: OpportunityFilters): Promise<OpportunityPage> {
    const response = await api.get<ApiResponse<OpportunityPage>>('/admin/opportunities', {
      params: {
        estado: filters.estado || undefined,
        cidade: filters.cidade || undefined,
        busca: filters.busca || undefined,
        apenasComPreco: filters.apenasComPreco || undefined,
        contato: filters.contato || undefined,
        page: filters.page ?? 0,
        size: filters.size ?? 50,
      },
    });
    return response.data.data;
  },

  // Telefone e e-mail do posto pelo CNPJ na Receita; só preenche o que estiver vazio
  async lookupContact(id: string): Promise<{ result: OpportunityContactLookup; message?: string }> {
    const response = await api.post<ApiResponse<OpportunityContactLookup>>(`/admin/opportunities/${id}/contato`);
    return { result: response.data.data, message: response.data.message };
  },

  // Busca em lote (uma consulta por segundo): pode levar alguns minutos
  async lookupContacts(filters: { estado?: string; cidade?: string; limite?: number }): Promise<DataImportRun> {
    const response = await api.post<ApiResponse<DataImportRun>>('/admin/opportunities/contato', null, {
      params: {
        estado: filters.estado || undefined,
        cidade: filters.cidade || undefined,
        limite: filters.limite || undefined,
      },
      timeout: 600000,
    });
    return response.data.data;
  },
};
